import * as React from "react"

import Inner from "~/components/Organisms/inner"
import ContentsTextBlock from "~/components/Molecules/contentsBlock"
import ContentsFooter from "~/components/Molecules/contentsFooter"
import Slider from "~/components/Molecules/works/slider"

import Data from "~/assets/data/stage7.json"
import Kv from "~/components/Molecules/works/kv"

import WorksItems from "~/components/Molecules/works/worksItems"

import Layout from "~/components/Organisms/layout"
import Seo from "~/components/seo"


const imageKv = "/images/stage7/stage7-kv.jpg"
const stage7 = () => (
  <Layout>
    <Seo title="第6回公演『話は明日にしましょ』" />
    <Kv
      data={Data}
      img={imageKv}
    />
    <Inner>
      <ContentsTextBlock 
        title={Data.about.title}
        lead={Data.about.lead}
      />
      <Slider
        title='ギャラリー'
        imageNum='26'
        stageNum='7'
      />
      <ContentsTextBlock 
        title={Data.staff.title}
        lead={Data.staff.lead}
      />
      <WorksItems/>
    </Inner>
    <ContentsFooter />
  </Layout>
)

export default stage7
